import { Weekday } from '@/features/accounts/types';

export interface DateWindowFields {
  from: string;
  to: string;
  weekdays: Weekday[];
}

export interface BlackoutFields {
  from: string;
  to: string;
}

export interface ConfigurationFormData {
  windows: DateWindowFields[];
  blackouts: BlackoutFields[];
  maxGapAscConsular: string;
  minDaysFromNow: string;
  minSameDayGap: string;
  allowCancellation: boolean;
  acceptWorseDate: boolean;
  preferredFacilities: string[];
}

interface LaterDateChoice {
  allowCancellation: boolean;
  acceptWorseDate: boolean;
}

export function acceptsLaterDate({
  allowCancellation,
  acceptWorseDate,
}: LaterDateChoice): boolean {
  return !allowCancellation && acceptWorseDate;
}
